/**
 * Registers some events for UI changes that need to be reflected in the CMS UI
 */

function registerCmsEvents() {
  $('body').on('show.bs.collapse', () => {
    $.publish('cms.viewport.change');
  });
  $('body').on('shown.bs.collapse', () => {
    $.publish('cms.viewport.changed');
  });
  $('body').on('hide.bs.collapse', () => {
    $.publish('cms.viewport.change');
  });
  $('body').on('hidden.bs.collapse', () => {
    $.publish('cms.viewport.changed');
  });
}

if (window.fcse && window.fcse.cms) {
  registerCmsEvents();
}


// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/pages/package/home/cmsAdapter.js